var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chart-contact-icon",attrs:{"data-cy":"chart-contact-icon"},on:{"click":_vm.onClick,"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_c('Icon',{attrs:{"icon":_vm.contactIconType,"size":_vm.iconSize,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }